import {ValueListener} from "./interfaces";

import {Households} from "../households/Households";
import EventPerson from "../eventsManager/EventPerson";

export interface UserProfile {
    personKey: string;
    name: string;
    displayName: string;
    avatar: any;
    email: string;
    createdAt: number;
    createdBy: string;
    nameTimestamp: number;
    attending: boolean;
    householdAttendance: number;
    household: Array<any>;
    isLoginLess: boolean;
};

export const observeCurrentUserProfile = (eventDataSource: any, listener: ValueListener<UserProfile>) => {

    listener = eventDataSource.wrapListener(listener);
    let eventPerson;
    let person;
    let households = new Households(null, {});

    const compute = function () {
        var profile: UserProfile = {
            personKey: null,
            name: null,
            displayName: null,
            avatar: null,
            email: null,
            createdAt: null,
            createdBy: null,
            nameTimestamp: null,
            attending: null,
            householdAttendance: null,
            household: null,
            isLoginLess: null,
        };

        if (person) {
            profile.personKey = person.getPersonKey();
            profile.household = person.getHousehold(households).findMembers(person._people) as Array<any>;
            profile.name = person.name || profile.name;
            profile.displayName = person.getDetail("displayName") || person.firstName || profile.displayName;
            profile.email = person.email || profile.email;
            profile.avatar = person.avatar || profile.avatar;
            profile.createdAt = person.createdAt || profile.createdAt;
            profile.createdBy = person.createdBy || profile.createdBy;
            profile.nameTimestamp = person.nameTimestamp || profile.nameTimestamp;
            profile.attending = person.getDetail("rsvp");
            if(profile.attending) {
                let a = profile.household;
                profile.householdAttendance = a.filter(b => b.getDetail("rsvp") === true).length;
            }
        }

        profile.isLoginLess = eventPerson.isLoginless();
        return profile;
    };

    const onUpdate = function () {
        listener.onValue(compute());
    };

    eventPerson = new EventPerson(eventDataSource, {onValue: function (p) {
        person = p;
        onUpdate();
    }});
};
